import {
  EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_REQUEST,
  EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_SUCCESS,
  EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_FAILURE,
  EMPLOYER_UPDATE_PHA_REQUEST_STATUS_REQUEST,
  EMPLOYER_UPDATE_PHA_REQUEST_STATUS_SUCCESS,
  EMPLOYER_UPDATE_PHA_REQUEST_STATUS_FAILURE,
  CALENDAR_UNAVAILABLE_EVENT_ADD_REQUEST,
  CALENDAR_UNAVAILABLE_EVENT_ADD_SUCCESS,
  CALENDAR_UNAVAILABLE_EVENT_ADD_FAILURE,
  CALENDAR_EVENT_EDIT_REQUEST,
  CALENDAR_EVENT_EDIT_SUCCESS,
  CALENDAR_EVENT_EDIT_FAILURE,
  SAVE_EMPLOYER_SETUP_DATA_REQUEST,
  SAVE_EMPLOYER_SETUP_DATA_SUCCESS,
  SAVE_EMPLOYER_SETUP_DATA_FAILURE,
  GET_EMPLOYER_SETUP_DATA_REQUEST,
  GET_EMPLOYER_SETUP_DATA_SUCCESS,
  GET_EMPLOYER_SETUP_DATA_FAILURE,
  RESET_EMPLOYER_STATUS,
  EMPLOYER_SETUP_DATA_UPDATED,
  FB_EMPLOYER_GET_REQUEST,
  FB_EMPLOYER_GET_SUCCESS,
  FB_EMPLOYER_GET_FAILURE,
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_SUCCESS,
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_SUCCESS,
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_FAILURE,
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_REQUEST,
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_FAILURE,
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_REQUEST,
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_SUCCESS,
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_FAILURE,
  EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_REQUEST,
  EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_SUCCESS,
  EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_FAILURE,
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_REQUEST,
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_SUCCESS,
  EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_FAILURE,
  EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_REQUEST,
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_REQUEST,
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_SUCCESS,
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_FAILURE,
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_REQUEST,
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_SUCCESS,
  EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_FAILURE,
  EMPLOYER_REPORT_PHA_GET_SUCCESS,
  EMPLOYER_REPORT_PHA_GET_FAILURE,
} from '../../actions/actionTypes';
import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

const INITIAL_STATE = {
  errorMessage: '',
  calUnavailableStatus: PENDING,
  phaRequestStatus: PENDING,
  phaRequestErrorMessage: null,
  setSetupDataStatus: null,
  saveSetupDataStatus: PENDING,
  getSetupDataStatus: PENDING,
  setupData: {},
  setupDataUpdated: null,
  fetchEmployerStatus: PENDING,
  beingUpdated: {},
  getOccHealthStatus: PENDING,
  saveOccHealthStatus: PENDING,
  occHealthRequirementsData: [],
  occHealthDepartmentsData: {},
  occHealthMasterDepartmentsData: {},
  getMedRecruiterClinicalLocationsStatus: PENDING,
  saveMedRecruiterClinicalLocationsStatus: PENDING,
  medRecruiterLocationsData: [],
  phaReportData: {},
  inviteRequestStatus: PENDING,
  inviteRequestError: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FB_EMPLOYER_GET_REQUEST:
      return {
        ...state,
        fetchEmployerStatus: REQUESTING,
      };
    case FB_EMPLOYER_GET_SUCCESS:
      return {
        ...state,
        fetchEmployerStatus: SUCCESS,
      };
    case FB_EMPLOYER_GET_FAILURE:
      return {
        ...state,
        fetchEmployerStatus: FAILED,
      };

    case EMPLOYER_SETUP_DATA_UPDATED:
      return { ...state, setupDataUpdated: action.payload?.itemsPath || null };
    case GET_EMPLOYER_SETUP_DATA_REQUEST:
      return { ...state, getSetupDataStatus: REQUESTING, errorMessage: null };
    case GET_EMPLOYER_SETUP_DATA_SUCCESS:
      return {
        ...state,
        getSetupDataStatus: SUCCESS,
        errorMessage: null,
        setupData: {
          ...state.setupData,
          ...action.payload,
        },
      };
    case GET_EMPLOYER_SETUP_DATA_FAILURE:
      return { ...state, getSetupDataStatus: FAILED, errorMessage: action.payload };

    case SAVE_EMPLOYER_SETUP_DATA_REQUEST:
      return {
        ...state,
        saveSetupDataStatus: REQUESTING,
        errorMessage: null,
        setupDataUpdated: null,
      };
    case SAVE_EMPLOYER_SETUP_DATA_SUCCESS:
      return {
        ...state,
        saveSetupDataStatus: SUCCESS,
        errorMessage: null,
      };
    case SAVE_EMPLOYER_SETUP_DATA_FAILURE:
      return { ...state, saveSetupDataStatus: FAILED, errorMessage: action.payload };

    case EMPLOYER_UPDATE_PHA_REQUEST_STATUS_REQUEST:
      return {
        ...state,
        phaRequestStatus: REQUESTING,
        phaRequestErrorMessage: null,
        beingUpdated: {
          ...state.beingUpdated,
          [action.payload.appointmentRequestId]: true,
        },
      };
    case EMPLOYER_UPDATE_PHA_REQUEST_STATUS_SUCCESS:
      const beingUpdatedSuccess = { ...state.beingUpdated };
      delete beingUpdatedSuccess[action.payload.appointmentRequestId];
      return {
        ...state,
        phaRequestStatus: SUCCESS,
        phaRequestErrorMessage: null,
        beingUpdated: beingUpdatedSuccess,
      };
    case EMPLOYER_UPDATE_PHA_REQUEST_STATUS_FAILURE:
      const beingUpdatedFailure = { ...state.beingUpdated };
      delete beingUpdatedFailure[action.payload.appointmentRequestId];
      return {
        ...state,
        phaRequestStatus: FAILED,
        phaRequestErrorMessage: action.payload?.error,
        beingUpdated: beingUpdatedFailure,
      };
    case EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_REQUEST:
      return { ...state, inviteRequestStatus: REQUESTING, inviteRequestError: null };
    case EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_SUCCESS:
      return { ...state, inviteRequestStatus: SUCCESS, inviteRequestError: null };
    case EMPLOYER_UPDATE_INVITE_REQUEST_STATUS_FAILURE:
      return { ...state, inviteRequestStatus: FAILED, inviteRequestError: action.payload };

    case CALENDAR_UNAVAILABLE_EVENT_ADD_REQUEST:
    case CALENDAR_EVENT_EDIT_REQUEST:
      return {
        ...state,
        calUnavailableStatus: REQUESTING,
        successMessage: null,
        errorMessage: null,
      };
    case CALENDAR_UNAVAILABLE_EVENT_ADD_SUCCESS:
    case CALENDAR_EVENT_EDIT_SUCCESS:
      return {
        ...state,
        calUnavailableStatus: SUCCESS,
        successMessage: null,
        errorMessage: null,
      };
    case CALENDAR_UNAVAILABLE_EVENT_ADD_FAILURE:
    case CALENDAR_EVENT_EDIT_FAILURE:
      return {
        ...state,
        calUnavailableStatus: FAILED,
        successMessage: null,
        errorMessage: action.payload,
      };
    case RESET_EMPLOYER_STATUS:
      const setupData = state.setupData;
      const occHealthRequirementsData = state.occHealthRequirementsData;
      const occHealthDepartmentsData = state.occHealthDepartmentsData;
      const occHealthMasterDepartmentsData = state.occHealthMasterDepartmentsData;
      const medRecruiterLocationsData = state.medRecruiterLocationsData;
      const phaReportData = state.phaReportData;
      return {
        ...INITIAL_STATE,
        setupData,
        occHealthRequirementsData,
        occHealthDepartmentsData,
        occHealthMasterDepartmentsData,
        medRecruiterLocationsData,
        phaReportData,
      };
    case EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_REQUEST:
    case EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_REQUEST:
    case EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_REQUEST:
      return { ...state, getOccHealthStatus: REQUESTING, errorMessage: null };
    case EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_SUCCESS:
      return {
        ...state,
        getOccHealthStatus: SUCCESS,
        errorMessage: null,
        occHealthRequirementsData: action.payload,
      };
    case EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_SUCCESS:
      return {
        ...state,
        getOccHealthStatus: SUCCESS,
        errorMessage: null,
        occHealthDepartmentsData: action.payload,
      };
    case EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        getOccHealthStatus: SUCCESS,
        occHealthMasterDepartmentsData: action.payload,
      };
    case EMPLOYER_OCC_HEALTH_DEPARTMENTS_GET_FAILURE:
    case EMPLOYER_OCC_HEALTH_REQUIREMENTS_GET_FAILURE:
    case EMPLOYER_OCC_HEALTH_MASTER_DEPARTMENTS_GET_FAILURE:
      return { ...state, getOccHealthStatus: FAILED, errorMessage: action.payload };
    case EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_REQUEST:
    case EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_REQUEST:
      return { ...state, saveOccHealthStatus: REQUESTING, errorMessage: null };
    case EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_SUCCESS:
    case EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_SUCCESS:
      return { ...state, saveOccHealthStatus: SUCCESS, errorMessage: null };
    case EMPLOYER_OCC_HEALTH_REQUIREMENTS_SAVE_FAILURE:
    case EMPLOYER_OCC_HEALTH_DEPARTMENTS_SAVE_FAILURE:
      return { ...state, saveOccHealthStatus: FAILED, errorMessage: action.payload };
    case EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_REQUEST:
      return { ...state, getMedRecruiterClinicalLocationsStatus: REQUESTING, errorMessage: null };
    case EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_SUCCESS:
      return {
        ...state,
        getMedRecruiterClinicalLocationsStatus: SUCCESS,
        errorMessage: null,
        medRecruiterLocationsData: action.payload,
      };
    case EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_GET_FAILURE:
      return {
        ...state,
        getMedRecruiterClinicalLocationsStatus: FAILED,
        errorMessage: action.payload,
      };
    case EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_REQUEST:
      return { ...state, saveMedRecruiterClinicalLocationsStatus: REQUESTING, errorMessage: null };
    case EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_SUCCESS:
      return { ...state, saveMedRecruiterClinicalLocationsStatus: SUCCESS, errorMessage: null };
    case EMPLOYER_MED_RECRUITER_CLINICAL_LOCATIONS_SAVE_FAILURE:
      return {
        ...state,
        saveMedRecruiterClinicalLocationsStatus: FAILED,
        errorMessage: action.payload,
      };
    case EMPLOYER_REPORT_PHA_GET_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        phaReportData: action.payload,
      };
    case EMPLOYER_REPORT_PHA_GET_FAILURE:
      return { ...state, errorMessage: action.payload };
    default:
      return state;
  }

  return state;
}
